import { Link } from "react-router";

import logoImage from "@/assets/images/common/logo.png";
import { pathNames } from "@/router/paths";

type LogoProps = {
  className?: string;
  size?: "sm" | "md" | "lg";
};

const sizeMap = {
  sm: "text-xl",
  md: "text-2xl",
  lg: "text-3xl",
};

export function Logo({ className = "", size = "md" }: LogoProps) {
  return (
    <Link
      to={pathNames.home}
      className={`inline-block font-bold tracking-tight text-yoyo-primary ${sizeMap[size]} ${className}`}
    >
      <img src={logoImage} width={149} alt="YOYO" />
    </Link>
  );
}
